import * as React from "react";
import { Text } from "@grandvisionhq/iris-ui";
const ProductBlockCaption = ({ children }) => {
  return /* @__PURE__ */ React.createElement(Text, { variant: "caption", component: "span" }, children);
};
export {
  ProductBlockCaption
};
//# sourceMappingURL=ProductBlockCaption.js.map
